"use client";

import { useEffect } from "react";

export default function RecaptchaChallenge() {
  useEffect(() => {
    if (typeof window.grecaptcha === 'undefined') {
      window.grecaptcha = {
        ready: function (cb: unknown) {
          // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
          // configuration. By default, any functions listed in its 'fns' property
          // are automatically executed when reCAPTCHA loads.
          const c = '___grecaptcha_cfg';
          window[c] = window[c] || {};
          (window[c]['fns'] = window[c]['fns'] || []).push(cb);
        }
      };
    }

    // Usage
    window.grecaptcha.ready(function () {
      try {
        window.grecaptcha.render("recaptchaContainer", {
          sitekey: "6Ld5FlwsAAAAALOq7xuZzXLq3jxaca1I4V2DSa_2"
        });
      } catch (e) {
        console.log('Skipping reCAPTCHA render');
      }

    });
  }, []);

  return <div>
    <script async src="https://www.google.com/recaptcha/api.js"></script>
    <div id="recaptchaContainer" />
  </div>
}